import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip/Tooltip.js';

const ICON_PROPS = {
  fill: ['default', 'gray', 'error', 'neutral', 'primary', 'success', 'warning', 'white', 'dark-gray', 'attention'],
  size: ['xlarge', 'large', 'medium', 'small', 'xsmall']
};
const SIZES = {
  xlarge: 32,
  large: 24,
  medium: 16,
  small: 12,
  xsmall: 8
};
function getSize(value) {
  return SIZES[value] ?? value;
}
const Icon = ({
  className,
  fill = 'default',
  name,
  size,
  title = name,
  tooltip,
  tooltipProps,
  ...otherProps
}) => {
  const baseClass = 'nui-icon';
  const nameClass = `${baseClass}--${name}`;
  const fillClass = fill ? `${baseClass}--${fill}` : false;
  const path = `#icon-${name}`;
  const tooltipContent = tooltip || tooltipProps?.content;
  const style = size ? {
    width: getSize(size),
    height: getSize(size)
  } : undefined;
  const icon = name === 'empty' ? /*#__PURE__*/React__default.createElement("span", {
    className: cx(baseClass, nameClass, className),
    style: style
  }) : /*#__PURE__*/React__default.createElement("svg", _extends({}, otherProps, {
    role: "img",
    className: cx(baseClass, nameClass, fillClass, className),
    style: style,
    focusable: "false"
  }), /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("use", {
    href: path,
    width: "100%",
    height: "100%"
  }));
  if (!tooltipContent) return icon;
  return /*#__PURE__*/React__default.createElement(Tooltip, _extends({}, tooltipProps, {
    content: tooltipContent
  }), icon);
};
Icon.propTypes = {
  /** optional custom className */
  className: PropTypes.string,
  /** name of the icon to display */
  name: PropTypes.string.isRequired,
  /** fill of the icon to display */
  fill: PropTypes.oneOf(ICON_PROPS.fill),
  /** icon size */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(ICON_PROPS.size)]),
  /** SVG `title` text for accessibility */
  title: PropTypes.string,
  /** props that will be passed to the Tooltip component */
  tooltipProps: PropTypes.shape({
    content: PropTypes.node
  }),
  /** shorthand for tooltipProps.content */
  tooltip: PropTypes.node
};
Icon.displayName = 'NuiIcon';
var Icon$1 = Icon;

export { ICON_PROPS, Icon$1 as default };
